document.addEventListener('DOMContentLoaded', () => {
  const bundleCards = document.querySelectorAll('.bundle-container');
  const qtyInput = document.querySelector('.js-product-form-main input[name="quantity"]');

  // ---------- BUNDLE CLICK HANDLER ----------
  bundleCards.forEach(card => {
    card.addEventListener('click', () => {
      const qty = parseInt(card.dataset.multiplier, 10);
      qtyInput.value = qty;

      bundleCards.forEach(c => c.classList.remove('active'));
      card.classList.add('active');

      qtyInput.dispatchEvent(new Event('change', { bubbles: true })); // update UI for AJAX carts etc.
    });
  });

  // ---------- QUANTITY CHANGE LOGIC ----------
  const syncBundleWithQty = () => {
    const currentQty = parseInt(qtyInput.value, 10);

    // Collect all bundle qty values
    const multipliers = [...bundleCards].map(card => parseInt(card.dataset.multiplier, 10));

    // Sort so we know the highest
    const maxBundle = Math.max(...multipliers);

    let matched = false;

    bundleCards.forEach(card => {
      const bundleQty = parseInt(card.dataset.multiplier, 10);

      // Exact match
      if (bundleQty === currentQty) {
        card.classList.add('active');
        matched = true;
      } else {
        card.classList.remove('active');
      }
    });

    // ---------- NEW RULE ----------
    if (!matched && currentQty > maxBundle) {
      // Lock to the highest multiplier bundle
      bundleCards.forEach(card => {
        if (parseInt(card.dataset.multiplier, 10) === maxBundle) {
          card.classList.add('active');
        }
      });
    }

    // If user reduces below lowest, no active
  };


  // Listen to all possible quantity changes
  qtyInput.addEventListener('change', syncBundleWithQty);
  qtyInput.addEventListener('input', syncBundleWithQty);

  // Shopify qty buttons trigger click events or input events
  document.addEventListener('click', (e) => {
    if (e.target.closest('.quantity-input__button')) {
      // Delay so Shopify can update the input first
      setTimeout(syncBundleWithQty, 50);
    }
  });

  // ---------- AUTO SELECT RECOMMENDED ----------
  
  const recommended = document.querySelector('.bundle-container[data-recommended="true"]');
  const toSelect =  bundleCards[0];

  if (toSelect) toSelect.click();
});
